import {useMutation} from "@tanstack/react-query"

import {api, SMSDraftReplyRequest, SMSDraftReplyResponse} from "./index"

type DraftSMSReplyParams = {
	customerID: string
	conversationID: string
	providerMessageId: string
} & SMSDraftReplyRequest

export function useDraftSMSReply() {
	return useMutation({
		mutationFn: ({
			customerID,
			conversationID,
			providerMessageId,
			...payload
		}: DraftSMSReplyParams): Promise<SMSDraftReplyResponse> =>
			api.customer.draftSMSReply(customerID, conversationID, providerMessageId, payload),
	})
}
